import { render, staticRenderFns } from "./CooperationEdit.vue?vue&type=template&id=55b32d2c&scoped=true&"
import script from "./CooperationEdit.vue?vue&type=script&lang=js&"
export * from "./CooperationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b32d2c",
  null
  
)

export default component.exports